import { useMemo } from 'react';
import { ID } from 'shared/types/id';
import { SmartList } from 'shared/types/smart-list';

import { useSmartLists } from './use-smart-lists';

export const useSmartListById = (id?: ID): SmartList | undefined => {
  const smartLists = useSmartLists();

  return useMemo(
    () => smartLists.find((list) => list.id === id),
    [smartLists, id],
  );
};
